export default {
    name: 'DogPurchaseTransactionFailed',
    components: {},
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() {},
    methods: {
        contactUsEmail(){
			window.location.href = 'mailto:services@lovemydogclub.com.au';
		}
    },
    // third party libraries
}